export function useFleetHealth(totalDevices?: number, activeDevices?: number) {
  const total = typeof totalDevices === "number" ? totalDevices : 0
  const active = typeof activeDevices === "number" ? activeDevices : 0
  const offline = total - active
  const healthPercent = total > 0 ? Math.round((active / total) * 100) : 0
  const hasData = total > 0

  return { total, active, offline, healthPercent, hasData }
}
